var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8.21601 12 8.41475 11.9182 8.57028 11.7628L15.2753 5.28425C15.4222 5.13701 15.5 4.95706 15.5 4.74438C15.5 4.3272 15.163 4 14.7137 4C14.4977 4 14.299 4.0818 14.1521 4.21268L8 10.1677L1.84793 4.21268C1.70104 4.0818 1.51094 4 1.28629 4C0.836982 4 0.5 4.3272 0.5 4.74438C0.5 4.95706 0.577765 5.13701 0.733295 5.28425L7.42972 11.7628C7.59389 11.9182 7.78399 12 8 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevronDown.78f7c6d455a5fe1b1ee6c4b0d6e7616b.svg";
export { ForwardRef as ReactComponent };